import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { TranslatePipe } from '@ngx-translate/core';
import { getNotificationStyle } from '@shared/utils/notification-styles.util';
import { BrnDialogContent } from '@spartan-ng/brain/dialog';
import { HlmButton } from '@spartan-ng/helm/button';
import { HlmDialog, HlmDialogContent } from '@spartan-ng/helm/dialog';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-notification-modal',
  imports: [
    BrnDialogContent,
    HlmDialog,
    HlmDialogContent,
    HlmButton,
    NgIcon,
    TranslatePipe,
  ],
  templateUrl: './notification-modal.component.html',
  styleUrl: './notification-modal.component.css',
})
export class NotificationModalComponent {
  private readonly notificationService = inject(NotificationService);
  private readonly router = inject(Router);

  /** Notificação ativa vinda do serviço */
  readonly notification = this.notificationService.activeErrorNotification;

  /** Controla a visibilidade do modal */
  readonly visible = computed(() => this.notification() !== null);

  /** Retorna a configuração de estilo baseada no tipo de notificação */
  readonly modalConfig = computed(() => {
    const notification = this.notification();
    const style = getNotificationStyle(
      notification?.notificationType ?? 'Error',
    );
    return {
      icon: style.primeIcon,
      iconClass: style.iconClass,
      headerClass: style.headerClass,
      bgClass: style.bgClass,
      titleKey: style.titleKey,
    };
  });

  /** Fecha o modal e marca como lido */
  close(): void {
    this.notificationService.dismissNotificationModal(true);
  }

  /** Navega para o link da notificação, na mesma aba, se existir */
  goToLink(): void {
    const link = this.notification()?.link;
    this.close();
    if (link) {
      void this.router.navigateByUrl(link);
    }
  }
}
